import React from 'react';
import {
    DataGrid,
} from '@mui/x-data-grid';
import { WrapperTable } from './styles';
import { esES } from '@mui/x-data-grid/locales';


export const TableMuiWithCsvExport = ({ rows, loading, columns, handleClick, apiRef }) => {
    return (
        <WrapperTable data-testid={"table-mui"}>
            <DataGrid
                apiRef={apiRef}
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                columns={columns}
                rows={rows}
                loading={loading}
                pageSizeOptions={[10, 25]}
                onRowSelectionModelChange={handleClick}
                checkboxSelection
                disableColumnFilter
                disableColumnMenu
                autoHeight
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                    },
                }}
            />
        </WrapperTable>
    );
}
